import { useEffect,useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PaymentUpdateAction } from "../../../Reducer/PaymentUpdateReducer";
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import Icon from "../../controls/Icons/Icon";
import { InvoiceNotesAction } from "../../../Reducer/InvoiceNotesReducer";
import DataGrid from "../../controls/DataGrid.js/DataGrid";
import { dateDisplayFormater } from "../../../Utils";
import { useNavigate } from 'react-router-dom';
import useFetchWithCancellation from "../../../customhooks/useFetchWithCancellation";
import InvoiceSummaryNotes from "./InvoiceSummaryNotes";
import { InvStatusEnum } from "../PCP/InvoiceGenerator/InvStatusEnum";
import { InvoiceMeetingAction } from "../../../Reducer/InvoiceMeetingsReducer";
import { UpdtInvoiceContAction } from "../../../Reducer/UpdatedInvoiceContentReducer";

export default function InvoiceSummary({ refresh, setRefreshGrid }) {
    const state = useSelector(state => state);
    const [invoiceDateflg, setinvoiceDateflg] = useState(false);
    const formRef = useRef();
    const dispatch = useDispatch();
    const [ShowNotes, setShowNotes] = useState(false);
    //const [dataGridUrl, setdataGridUrl] = useState(state.projectdetail.API + "/client/ClientFormGrid");
    const [gridUrl, setGridUrl] = useState(state.projectdetail.API + "/invoice/GetInvoiceGridList");
    const [loading, setLoading] = useState(false);
    const [refreshGridd, setrefreshGridd] = useState(false);
    const navigate = useNavigate();
    const [selectinvId, setselectinvId] = useState(0);
    const [invStatusId, setinvStatusId] = useState(0);
    const [invNumber, setinvNumber] = useState(0);
    const { fetchData } = useFetchWithCancellation();

    useEffect(() => {
        dispatch({ type: PaymentUpdateAction.UnSelectPaymentUpdateData, payload: "" });
       // setRefreshGrid(refreshGrid);
    }, [refresh,setRefreshGrid]);

    const handleChkBox = (e, rowData) => {
       // console.log("rowData");
      //  console.log(rowData);
        if (e.target.checked) {
            if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
                var selectedChkbox = "chk_" + state.selPayUpdtData.Id;
                if (document.getElementById(selectedChkbox).checked) {
                    document.getElementById(selectedChkbox).checked = false;
                }
            }
            dispatch({ type: PaymentUpdateAction.SelectPaymentUpdateData, payload: rowData });
            //console.log(rowData);
        } else {
            dispatch({ type: PaymentUpdateAction.UnSelectPaymentUpdateData, payload: rowData });
        }

    }
    const handleModify = (rowData) => {
        dispatch({ type: InvoiceMeetingAction.RemoveAllInvoiceMeeting });
        dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
        let url = "";
        if (rowData.isModify) {
             url = "/admin/pcpform/" + rowData.ClientId + "/pcpinvoicegenerator?invid=" + rowData.Id
        } else {
           url= "/admin/pcpform/" + rowData.ClientId + "/pcpinvoicegenerator?invid=" + rowData.Id + "&&view=true"
        }
     
        navigate(url);
    };
    const handleView = (rowData) => {
        let url = "/admin/pcpform/" + rowData.ClientId + "/pcpinvoicegenerator?invid=" + rowData.Id + "&&view=true"
        navigate(url);
    };
    const options = {
        dataType: "server",
        showExport: false,
        showRefresh: false,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "InvoiceSummary",
        // toolbar: (state.access.add ? <div><Button onClick={handleAdd}>Add New PCP</Button> <Button onClick={handleAdd}>Add New Spending Plan</Button></div> : <div></div>)
    };

    //useEffect(() => {
    //    setRefreshGrid(refresh);
    //}, []);
    const columns = [
        {
            field: "",
            title: "",
            align: 'left',
          //  border: 3,
         //   borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            formatter: (cellContent, rowData) => {
                return (<div>
                    {state.access.edit ? <input type="checkbox" id={"chk_" + rowData.Id}
                        className="btn-xs me-2 mb-2 p-0"
                        onClick={(e) => {
                            handleChkBox(e, rowData);
                        }}
                    /> : ""}
                </div>);
            },
        },
        //{
        //    field: "",
        //    title: "",
        //    //field: "FirstName",
        //    //title: "First Name",
        //    //sortName: "FirstName",
        //    //sortable: true,
        //  //  border: 3,
        //  //  borderstyle: "3px ridge #E5FAE7",
        //  //  align: 'center',
        //    formatter: (cellContent, row, rindex) => {
        //        return (<div>
        //            {rindex + 1}
        //        </div>);
        //    },
        //},
        {
            field: "InvoiceNumber",
            title: "Invoice Number",
            sortable: true,
            align: 'left',
            //  border: 3,
            //  borderstyle: "3px ridge #E5FAE7",
            //  align: 'center',
            formatter: (cellContent, row) => {
               // if (row.isModify) {
                    return (
                        <div>
                            {state.access.edit ?
                                <Button
                                    className="btn-xs me-2 mb-2 p-0" variant="link"
                                    onClick={() => handleModify(row)}
                                >{row.InvoiceNumber}</Button> : ""}

                        </div>
                    );
                //} else {
                //    return (
                //        <div>
                //            {row.InvoiceNumber}
                //        </div>
                //    );
                //}
            }
        },
        {
            field: "ClientName",
            title: "Client Name",
            align: 'left',
          //  border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            sortable: true,
            visible: true,

        },
        //{
        //    field: "InvoiceNumber",
        //    title: "Invoice Number",
        //    sortable: true,
        //  //  border: 3,
        //  //  borderstyle: "3px ridge #E5FAE7",
        //  //  align: 'center',
        //    formatter: (cellContent, row) => {
        //        if (row.isModify) {
        //            return (
        //                <div>
        //                    {state.access.edit ?
        //                        <Button
        //                            className="btn-xs me-2 mb-2 p-0" variant="link"
        //                            onClick={() => handleModify(row)}
        //                        >{row.InvoiceNumber}</Button> : ""}

        //                </div>
        //            );
        //        } else {
        //            return (
        //                <div>
        //                    {row.InvoiceNumber}
        //                </div>
        //            );
        //        }
        //    }
        //},            
        {
            field: "InvoiceDate",
            title: "Inv Date",
            align: 'left',
            formatter: dateDisplayFormater,
         //   border: 3,
         //   borderstyle: "3px ridge #E5FAE7",
         //   align: 'center',
        },
        {
            field: "InvoiceAmount",
            title: "Inv Amt",
            align: 'left',
          //  border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            visible: true,
        },
        {
            field: "ReceivedAmount", //PaidtoIFAmount
            title: "Recvd Amt",
            align: 'left',
          //  border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            formatter: (cellContent, row) => {
                return (
                    <div style={{width:'60px'}}>{row.ReceivedAmount}
                    </div>
                );
            }
        },
        {
            field: "PaidtoIFAmount", //PaidtoIFAmount
            title: "Paid Amt",
            align: 'left',
            //  border: 3,
            //  borderstyle: "3px ridge #E5FAE7",
            //  align: 'center',
            formatter: (cellContent, row) => {
                return (
                    <div style={{ width: '60px' }}>{row.PaidtoIFAmount}
                    </div>
                );
            }
        },
        {
            field: "StatusDescription",
            title: "Status",
            align: 'left',
           // border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            sortable: true,
            visible: true,
            formatter: (cellContent, row) => {
                let btnColor = 'black';
                if (row.StatusId == InvStatusEnum.Draft) btnColor = 'brown';
                if (row.StatusId == InvStatusEnum.SentforApproval) btnColor = '#2F918F';
                if (row.StatusId == InvStatusEnum.Approved) btnColor = 'green';
                if (row.StatusId == InvStatusEnum.Rejected) btnColor = 'red';
                if (row.StatusId == InvStatusEnum.Returned) btnColor = 'orange';
                if (row.StatusId == InvStatusEnum.SentforParentApproval) btnColor = 'blue';
                return (
                    <div > <p style={{ color: btnColor,bold:'true' }}>{row.StatusDescription}</p> </div>
                        
                );
            }
        },
        
        {
            field: "AgeSinceLastUpdate",
            title: "last update (In days)  ",
            align: 'left',
            width:'80px',
           // border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
            //  align: 'center',
            formatter: (cellContent, row) => {
                let textColr = "black";
                if (row.AgeSinceLastUpdate <= 4) {
                    textColr = "green";
                }
                else if (row.AgeSinceLastUpdate > 4 && row.AgeSinceLastUpdate <= 7) {
                    textColr = "#FFBF00";
                }
                else if (row.AgeSinceLastUpdate > 7) {
                    textColr = "red";
                }
                return (
                 
                    <div style={{ color: textColr, bold: 'true' }}>{row.AgeSinceLastUpdate} 
                    </div>
                );
            }
           
        },
        {
            
            field: "",
            title: "",
            align: 'left',
           
            formatter: (cellContent, rowData) => {
                return (<div> &nbsp;&nbsp;&nbsp;&nbsp;
                   
                </div>);
            },
        },
        {
            field: "InvoiceAge", 
            title: "Inv Age      (In days)  ",
            align: 'left',
            width: '80px',
            sortable: false,
            formatter: (cellContent, row) => {
                let textColr = "black";
                if (row.InvoiceAge <= 4) {
                    textColr = "green";
                }
                else if (row.InvoiceAge > 4 && row.InvoiceAge <= 7) {
                    textColr = "#FFBF00";
                }
                else if (row.InvoiceAge > 7) {
                    textColr = "red";
                }
                return (

                    <div style={{ color: textColr, bold: 'true' }}>{row.InvoiceAge}
                    </div>
                );
            }
        },
        {
            field: "InvoiceOwnerName",
            title: " IF ",
            align: 'center',
           // border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            sortable: false,

        },
        //{
        //    field: "InvoiceOwnerId",
        //    title: "Invoice OwnerId",
        //    border: 3,
        //    borderstyle: "3px ridge #E5FAE7",
        //    align: 'center',
        //    sortable: false,

        //},
        {
            field: "CreatedByName",
            title: "Created By",
            align: 'left',
           // border: 3,
           // borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            sortable: false,

        },
        {
            field: "InvoicetypeName",
            title: "Inv Type",
            align: 'left',
          //  border: 3,
          //  borderstyle: "3px ridge #E5FAE7",
          //  align: 'center',
            sortable: false,

        },
        {
            dataField: "",
            title: "Notes",
            text: "Notes",
            align: 'left',
          //  border: 3,
           // borderstyle: "3px ridge #E5FAE7",
           // align: 'center',
            formatter: (cellContent, rowData) => {
                return (<div>
                    {state.access.edit ? <Button text="Notes" variant="link" tooltip="Notes"
                        className="btn-xs me-2 p-0"
                        onClick={(e) => {
                            handleNotes(e, rowData);
                        }}
                    > <Icon name="BsPencilSquare" title="Notes" className='fs-5' /></Button> : ""}
                    {state.access.delete && state.access.user?.fkRoleId == 1 ? <Button variant="link"
                        className="btn-xs p-0" style={{ color: 'red' }}
                        onClick={() => handleDelete(rowData)}
                    >
                        <Icon name="BsTrash" className='fs-5' />
                    </Button> : ""}
                </div>);
            },
        },
        //{
        //    dataField: "",
        //    title: "View",
        //    text: "View Invoice",
        //   // border: 3,
        //  //  borderstyle: "3px ridge #E5FAE7",
        //  //  align: 'center',
        //    formatter: (cellContent, row) => {
        //        return (<div>
        //            {state.access.edit ? <Button text="View" variant="link" tooltip="View Invoice"
        //                className="btn-xs me-2 p-0"
        //                onClick={() => handleView(row)}
        //            > <Icon name="BsEyeFill" title="View" className='fs-5' /></Button> : ""}
        //        </div>);
        //    },
        //},
    ];
    const handleEdit = (res, to) => {
      //  console.log("Edit Invoice: ", res, to);
    };
    const handleDelete = (res) => {
        console.log("Delete Invoice: ", res);

        window.confirm("Do you want to delete the Invoice and its related data?", function () {
          //  setLoading(true);
            fetchData(state.projectdetail.API + "/Invoice/DeleteInvoice?Id=" + res.Id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },

            }).then(response => response.json()).then((res) => {
                if (res) {
                   // window.alert("Deleted successfuly");
                    setRefreshGrid(prev => !prev);
                    setrefreshGridd(!refreshGridd)
                   
                }
                else {
                    window.alert(res, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("Client.js ==> delete", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
              //  setLoading(false);
            });
        })

    };
   // };
    //const columns = [
    //    {
    //        field: "FirstName",
    //        title: "First Name",
    //        sortName: "FirstName",
    //        sortable: true,
    //    },
    //    {
    //        field: "LastName",
    //        title: "Last Name",
    //        sortable: true,
    //    },
    //    //{
    //    //    field: "DOB",
    //    //    title: "DOB",
    //    //    sortable: true,
    //    //    formatter: dateDisplayFormater
    //    //},
    //    {
    //        field: "UCINumber",
    //        title: "UCI Number",
    //        sortable: true,
    //        visible: true,
    //    },
    //    {
    //        field: "MotherName",
    //        title: "Mother's Name",
    //        sortable: true,
    //    },
    //    {
    //        field: "spendingPlanId",
    //        title: "SpendingPlan",
    //        sortable: false,
    //        visible: false,
    //    },
    //    {
    //        field: "FatherName",
    //        title: "Father's Name",
    //        sortable: true,
    //        visible: true,
    //    },
    //    //{
    //    //    field: "MobileNumber",
    //    //    title: "Contact No.",
    //    //    sortable: true,
    //    //},
    //    {
    //        field: "CreatedBy",
    //        title: "Created By",
    //        sortable: false,
    //    },
    //    {
    //        field: "CreatedDate",
    //        title: "Created Date",
    //        sortable: false,
    //        formatter: dateDisplayFormater
    //    },

    //    {
    //        dataField: "remove",
    //        title: "",
    //        text: "Delete",
    //        formatter: (cellContent, row) => {
    //            return (<div>
    //                {state.access.edit ? <Button text="PCP" variant="link" tooltip="PCP"
    //                    className="btn-xs me-2 p-0" variant="link"
    //                    onClick={() => handleEdit(row, 1)}> <Icon name="BsPeopleFill" title="PCP" className='fs-5' /></Button> : ""}

    //                {state.access.edit ? <Button variant="link" style={{ color: row.spendingPlanId > 0 ? '#ffcc00' : 'grey' }} text="Expense" tooltip="Spending Plan"
    //                    className="btn-xs p-0"
    //                    onClick={() => handleEdit(row, 2)}>
    //                    <Icon title="Spending Plan" name="BsPiggyBankFill" className='fs-5' />
    //                </Button> : ""}
    //                {state.access.delete && state.access.user?.fkRoleId == 1 ? <Button variant="link"
    //                    className="btn-xs p-0" style={{ color: 'red' }}
    //                   // onClick={() => handleDelete(row)}
    //                >
    //                    <Icon name="BsTrash" className='fs-5' />
    //                </Button> : ""}
    //            </div>
    //            );
    //        },
    //    }
    //];

    const handleNotes = (e, rowData) => {
        dispatch({ type: InvoiceNotesAction.AddInvIDForNotes, payload: rowData.Id });
        setselectinvId(rowData.Id);
        setinvStatusId(rowData.StatusId);
        setShowNotes(!ShowNotes);
        setinvNumber(rowData.InvoiceNumber);
        //InvoiceSummaryNotes
        return true;
    }

    const CloseNotes = () => {
        dispatch({ type: InvoiceNotesAction.RemInvIDForNotes });
        setShowNotes(false);
    }
    const CloseNotestest = (flg) => {
        setShowNotes(flg);
    }
    return (
        //<ErrorBoundary FallbackComponent={ErrorHandler}>
        //<Form noValidate validated={validated} ref={formRef}>
        <div>
            <div>
                    {/*Invoice Summary Page*/}
                    <Row>
                    <Col md={12}>
                    <Card>
                    <Card.Body>
                                {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                                <DataGrid url={gridUrl} classes="table table-striped" options={options} columns={columns} refresh={refreshGridd} />
                    </Card.Body>
                    </Card>
                    </Col>
                </Row>

                <Modal show={ShowNotes} onHide={CloseNotes} size="lg" backdrop="static">
                    <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                        <h4>Invoice Notes</h4>
                        <CloseButton onClick={CloseNotes} className="btn-close" />
                    </Modal.Header>
                    <Modal.Body>
                        <InvoiceSummaryNotes invoiceId={selectinvId} onCancel={CloseNotes} StatusId={invStatusId} InvoiceNumber={invNumber} saveAfter={CloseNotestest} />
                    </Modal.Body>
                </Modal>

            </div>
        </div>
            );
    {/*    </Form>*/}
    {/*</ErrorBoundary>*/}

}